// extracted by mini-css-extract-plugin
export default {"drawer":"xW","drawerheader":"yW","retake_quiz_bottom_bar":"zW","extra_drawer":"AW","not_answered_questions":"BW","question_ui":"CW","accordion_details":"EW","retake_quiz":"FW","accordions":"GW","accordion_root":"HW","accordion_summary_text":"IW","animation":"JW","show_animation":"KW","overflow_hidden":"LW"};
    if(module.hot) {
      // 1730991511448
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  